import { render, staticRenderFns } from "./add.vue?vue&type=template&id=b3d06e3c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=b3d06e3c&lang=less&scoped=true&"
import style1 from "./add.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d06e3c",
  null
  
)

export default component.exports